<template>
  <div :class="{contentWrap:true,noNav:$store.state.isWx}">
    <div class="container">
      <van-nav-bar :title="title" fixed v-if="!$store.state.isWx" left-arrow @click-left="$router.go(-1)"/>
      <noData v-if="nodata"></noData>
      <netError v-if="netError"></netError>
      <scroll>
        <li class="mgb-2" v-for="(value,index) in searchlist" :key="index" @click="toDeail(value.ioId)">
          <van-cell-group class="pdb-3 por">

            <van-cell value="已开票" icon="clock" is-link >
              <template slot="title">
                <span class="van-cell-text" >&nbsp;</span>
              </template>
            </van-cell>
            <span class="title-data" >{{value.invoiceDate}}</span>
            <div class="detail clear fz-22">
              <p>电子发票</p>
              <p>{{value.invoiceProject}}</p>
              <p class="price fr">{{value.invoiceMoney}}<span class="fz-3">元</span> </p>
            </div>
          </van-cell-group>
        </li>
        <!--</van-list>-->
      </scroll>
      <!--<van-list-->
      <!--v-model="loading"-->
      <!--:finished="finished"-->
      <!--:offset="offset"-->
      <!--@load="onLoad"-->
      <!--class="content"-->
      <!--&gt;-->
    </div>
  </div>
</template>

<script>
  import noData from '@/components/NoData.vue'
  import netError from '@/components/NetError.vue'
  export default {
    name: 'InvoiceList',
    data () {
      return {
        title: this.$route.meta.title,
        // 无数据
        nodata: true,
        // 网络错误
        netError: false,
        loading: false,
        finished: false,
        offset: 100,
        searchlist: []
      }
    },
    components: {
      noData,
      netError
    },
    created () {
      this.getlist()
    },
    methods: {
      // 得到列表
      _poseData (data) {
        if (data.status !== 'success') {
          this.netError = true
          return false
        };

        this.netError = false
        if (data.data.length !== 0) {
          this.searchlist = data.data
          this.nodata = false
        } else {
          this.searchlist = []
          this.nodata = true
        };
      },
      async getlist () {
        // 单位
        if (Number(this.$route.query.typeRadio) === 0) {
          let params = {buyerTel: this.$route.query.phone, buyerTaxpayerNum: this.$route.query.number, invoiceCategory: '2'}
          const data = await this.$http.getgetSavedInvoices(params)
          this._poseData(data)
        }

        // 个人
        if (Number(this.$route.query.typeRadio) === 1) {
          let params = {buyerTel: this.$route.query.phone, buyerName: this.$route.query.username, invoiceCategory: '1'}
          const data = await this.$http.getgetSavedInvoices(params)
          this._poseData(data)
        }
      },
      // 跳详情
      toDeail (vid) {
        this.$router.push(`/invoiceDetail/${vid}`)
      }

    }
  }
</script>

<style scoped lang="stylus">
  .all
    font-size: .28rem
    height: 100%
  .detail
    position: relative
    padding: .1rem .3rem
    padding-bottom 0
    p
      line-height: .5rem
    .price
      font-size: .5rem
      color: #EC6E06
      position: absolute
      bottom:0
      right:.3rem

  .van-cell-text
    color: #A5A5A5
  .title-data
    box-sizing: border-box;
    position: absolute
    top: 13px
    left: .7rem
    background-color: #fff;
    color: #A5A5A5;
    font-size: 14px;
</style>



// WEBPACK FOOTER //
// src/page/InvoiceList.vue